import React from 'react';
import {
  KpiItemRenderer,
} from '@workboard/ui-search';

const KpiRow = ({
  id, item, selectedItems, toggleChkBox,
}) => {
  const type = id;
  const itemId = `item-chk-${type}-${item.id}`;
  const isChecked = selectedItems.includes(item.id);

  return (
    <div key={`${type}_${item.id}`} className="rectbox-row">
      <div className="rectbox-col">
        <div className="chkbox wbcheckboxcomp" data-testid="chkbox wbcheckboxcomp" style={{ marginTop: '5px' }}>
          <input
            type="checkbox"
            className="css-checkbox"
            checked={isChecked}
            value={item.id}
            name="items[]"
            onChange={(e) => toggleChkBox(e, item)}
            id={itemId}
          />
          <label className="css-label modalParaText" htmlFor={itemId} />
        </div>
      </div>
      <div className="rectbox-col rectbox-col-goal rectbox-col-line" style={{ width: '90%' }}>
        <KpiItemRenderer item={item} valuePrecision={2} />
      </div>
    </div>
  );
};

export default KpiRow;
